import styled from 'styled-components';
import { Link as LinkElement } from '../../atoms';
export const Link = styled(LinkElement).attrs(() => ({
  fontSize: 2,
  fontWeight: '900',
  underlineOnHover: true,
  hover: true,
  padding: 0,
  color: 'primary.base'
}))``;